class EmailSignInController {
    static create(params) {
        return new EmailSignInController(params);
    }

    constructor({env}) {
        this.env = env;
        this.dialog = env.getDialog('user-sign-in-dialog');

        this.initEvents();
    }

    initEvents() {
        this.env.onNav('userSignIn', ({email = ''} = {}) => this.show({email}));

        this.dialog.on('submitGesture', () => this.onSubmitGesture());
        this.dialog.on('createAccountLink:click', () => this.onCreateAccountClick());
        this.dialog.on('resetPasswordLink:click', () => this.onResetPasswordClick());
    }

    getEmail() {
        return this.dialog.getEmail();
    }

    onCreateAccountClick() {
        this.env.navTo('createAccount', {email: this.getEmail()});
    }

    onResetPasswordClick() {
        this.env.navTo('resetPassword', {email: this.getEmail()});
    }

    async onSubmitGesture() {
        var proxy = this.env.getProxy(),
            {email, password} = this.dialog.getState(),
            guestSectionActive = this.dialog.guestSectionActive(),
            emailRequired = !guestSectionActive && !email,
            passwordRequired = !guestSectionActive && !password;

        this.dialog.clearErrors();

        if (emailRequired) {
            this.dialog.addEmailRequiredError();
            return;
        }
        else if (passwordRequired) {
            this.dialog.addPasswordRequiredError();
            return;
        }

        try {
            this.dialog.setSubmitting(true);

            await (guestSectionActive ? proxy.authenticateGuest() : proxy.authenticateEmailUser({email, password}));

            this.dialog.getForm().submit();
        }
        catch (error) {
            this.dialog.setSubmitting(false);

            if (error.hasType('InvalidUserCredentials')) {
                this.dialog.addAccountSectionError('Please provide a valid email address and password to sign in.');
            }
            else if (error.hasType('UserNotActivated')) {
                this.env.navTo('userNotActivated', {email: this.getEmail()});
            }
            else if (error.hasType('MaxConcurrentUsersExceeded')) {
                this.env.showDialog('user-limit-exceeded-dialog').then(() => this.dialog.show());
            }
            else {
                throw error;
            }
        }
    }

    show({email}) {
        this.dialog.clearErrors();
        this.dialog.clearPassword();
        this.dialog.setEmail(email);
        this.dialog.show();
        this.dialog.focusEmailField();
    }
}

export default EmailSignInController;